var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import singleSpaReact from "single-spa-react";
export var mount = (_a = singleSpaReact({
    React: React,
    ReactDOM: ReactDOM,
    rootComponent: App,
    errorBoundary: function (err, info, props) {
        return _jsx("div", { children: "This renders when a catastrophic error occurs" });
    },
}), _a.mount), unmount = _a.unmount, bootstrap = _a.bootstrap;
